import User from '../../../_shared/models/User';

export interface Auth {
  user: User;
  system: {
    configurations: [];
    termsAndConditions: [];
  };
  tokens: {
    authenticationToken: string;
    refreshToken: string;
  };
  expiresAt?: number;
}

// TODO: Add Swagger Request
export const initialState: Auth = {
  user: undefined,
  system: {
    configurations: undefined,
    termsAndConditions: undefined
  },
  tokens: undefined
};

// TODO: Add Swagger Response model
export const format = payload => {
  const newState: Auth = {
    user: payload.user,
    system: {
      configurations: payload.system.configurations,
      termsAndConditions: payload.system.termsAndConditions
    },
    tokens: {
      authenticationToken: payload.authenticationToken,
      refreshToken: payload.refreshToken
    }
  };
  return newState;
};
